import React, { useContext, useState } from 'react'
import { Trans, t } from '@lingui/macro'
import IconButton from '../../components/common/form/button/IconButton'
import IconSettings from '../../components/common/icon/IconSettings'
import { Drawer } from '../../components/common/page/drawer/Drawer'
import DrawerItem from '../../components/common/page/drawer/DrawerItem'
import Input from '../../components/common/form/input/Input'

import { ManageDashboardPageContext } from './manage/ManageDashboardPage'
import Textarea from '../../components/common/form/textarea/Textarea'
import { ButtonDanger } from 'front-end/src/components'
import IconTrash from '../../components/common/icon/IconTrash'
import ColorPickerButton from '../../components/common/color-picker-button/ColorPickerButton'

import { staticLinks } from 'shared/linkBuilder'
import { navigateTo } from '../../app/util/appHistory'
import GeneralRemoveModal from '../../components/common/general-remove-modal/GeneralRemoveModal'
import {
  usePatchDashboardMutation,
  useDeleteDashboardMutation
} from './DashboardDrawerWithGearButton.codegen'

export const DashboardsDrawerWithGearButton = () => {
  const { dashboard, refetch } = useContext(ManageDashboardPageContext)
  const [showEditDrawer, setShowEditDrawer] = useState<boolean>(false)
  const [removalModalVisible, showRemovalModal] = useState(false)
  const [patchFn] = usePatchDashboardMutation({
    onCompleted: refetch
  })
  const [deleteFn] = useDeleteDashboardMutation()

  return (
    <>
      <IconButton
        icon={<IconSettings />}
        hint={t`Settings`}
        color="medium"
        onClick={() => {
          setShowEditDrawer(true)
        }}
      />

      <Drawer
        className="DashboardsDrawer"
        title={t`Settings`}
        show={showEditDrawer}
        onHide={() => {
          setShowEditDrawer(false)
        }}
      >
        <DrawerItem label={t`Name`} className="full-width">
          <Input
            light
            defaultValue={dashboard.title}
            debouncedOnChange={(value) => {
              patchFn({
                variables: {
                  id: dashboard.id,
                  data: {
                    title: value
                  }
                }
              })
            }}
          />
        </DrawerItem>

        <DrawerItem label={t`Purpose statement`} className="full-width">
          <Textarea
            // @ts-expect-error
            value={dashboard.description}
            rows={5}
            debouncedOnChange={(value) => {
              patchFn({
                variables: {
                  id: dashboard.id,
                  data: {
                    description: value
                  }
                }
              })
            }}
          />
        </DrawerItem>
        <DrawerItem label={t`Colour`} className="full-width">
          <ColorPickerButton
            color={dashboard.color || '#00bb77'}
            onChange={(color) => {
              patchFn({
                variables: {
                  id: dashboard.id,
                  data: {
                    color
                  }
                }
              })
            }}
          />
        </DrawerItem>
        <DrawerItem label={t`Delete this dashboard`}>
          <GeneralRemoveModal
            show={removalModalVisible}
            entityName={t`dashboard`}
            confirmButton={t`Delete`}
            onDeleted={() => showRemovalModal(false)}
            onCanceled={() => showRemovalModal(false)}
            operation={async () => {
              await deleteFn({
                variables: {
                  id: dashboard.id
                }
              })
              navigateTo(staticLinks.dashboards)
            }}
          />

          <ButtonDanger
            onClick={async () => {
              showRemovalModal(true)
            }}
            leftIcon={<IconTrash />}
          >
            <Trans>Delete</Trans>
          </ButtonDanger>
        </DrawerItem>
      </Drawer>
    </>
  )
}
